<template>
	<svg t="1686291764201" class="icon" viewBox="0 0 1489 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1920"
		id="mx_n_1686291764202" xmlns:xlink="http://www.w3.org/1999/xlink" width="290.8203125" height="200">
		<path
			d="M393.161697 1019.942788h310.30303V0h-310.30303v1019.942788z m-393.161697 0h310.30303V0H0v1019.942788zM786.331152 0v1019.942788h310.30303V0h-310.30303z m387.878787 0v1019.942788h310.303031V0h-310.303031z"
			p-id="1921"></path>
	</svg>
</template>
